export const PARSING_RESUME = "parsing_resume"
export const PARSING_RESUME_SUCCESSFUL = "parsing_resume_successfull"
export const PARSING_RESUME_FAILED = "parsing_resume_failed"
export const CHECK_DUPLICATE_CANDIDATE='check_duplicate_candidate'
export const CHECK_DUPLICATE_CANDIDATE_SUCCESSFUL='check_duplicate_candidate_successfully'
export const CHECK_DUPLICATE_CANDIDATE_FAILED='check_duplicate_candidate_failed'
export const ADD_CANDIDATE = "add_candidate"
export const ADD_CANDIDATE_SUCCESSFUL = "add_candidate_successfully"
export const ADD_CANDIDATE_FAILED = "add_candidate_failed"
export const UPDATE_CANDIDATE = "update_candidate"
export const UPDATE_CANDIDATE_SUCCESSFUL = "update_candidate_successfully"
export const UPDATE_CANDIDATE_FAILED = "update_candidate_failed"
export const GET_CANDIDATE_DATA = "get_candidate_data"
export const GET_CANDIDATE_DATA_SUCCESSFUL = "get_candidate_data_successfully"
export const GET_CANDIDATE_DATA_FAILED = "get_candidate_data_failed"
//getNationality
export const GET_NATIONALITY = "GET_NATIONALITY"
export const GET_NATIONALITY_SUCCESSFUL = "GET_NATIONALITY_SUCCESSFUL"
export const GET_NATIONALITY_FAILED = "GET_NATIONALITY_FAILED"
//get countries
export const GET_COUNTRIES ="GET_COUNTRIES";
export const GET_COUNTRIES_SUCCESS ="GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILED ="GET_COUNTRIES_FAILED";
//get state for resident
export const GET_STATE ="GET_STATE";
export const GET_STATE_SUCCESS ="GET_STATE_SUCCESS";
export const GET_STATE_FAILED ="GET_STATE_FAILED";

//get ip location
export const CANDIDATE_GET_IP_LOCATION = "CANDIDATE_GET_IP_LOCATION"
export const CANDIDATE_GET_IP_LOCATION_SUCCESSFULL = "CANDIDATE_GET_IP_LOCATION_SUCCESSFULL"
export const CANDIDATE_GET_IP_LOCATION_FAILED = "CANDIDATE_GET_IP_LOCATION_FAILED"

//get state for permanent address
export const PERMANENT_GET_STATE ="PERMANENT_GET_STATE";
export const PERMANENT_GET_STATE_SUCCESS ="PERMANENT_GET_STATE_SUCCESS";
export const PERMANENT_GET_STATE_FAILED ="PERMANENT_GET_STATE_FAILED";

//get state for qualiification
export const GET_QUALIFICATION_STATE ="GET_QUALIFICATION__STATE";
export const GET_QUALIFICATION_STATE_SUCCESS ="GET_QUALIFICATION_STATE_SUCCESS";
export const GET_QUALIFICATION_STATE_FAILED ="GET_QUALIFICATION_STATE_FAILED";


//get state and country

export const GET_STATE_AND_COUNTRY_DETAILS = "GET_STATE_AND_COUNTRY_DETAILS"
export const GET_STATE_AND_COUNTRY_DETAILS_SUCCESS = "GET_STATE_AND_COUNTRY_DETAILS_SUCCESS"
export const GET_STATE_AND_COUNTRY_DETAILS_FAIL = "GET_STATE_AND_COUNTRY_DETAILS_FAIL"


//secondardy details get state and country

export const GET_SECONDARY_STATE_AND_COUNTRY_DETAILS = "GET_SECONDARY_STATE_AND_COUNTRY_DETAILS"
export const GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_SUCCESS = "GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_SUCCESS"
export const GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_FAIL = "GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_FAIL"

